<template lang="pug">
  .addresses
    Address.edit-address(v-for="address in addresses" :key="address.id" :address="address")
    Address.add-address
</template>

<script>
import { mapGetters } from 'vuex';

import Address from './Addresses/Address';

export default {
    name: 'Addresses',
    components: {
        Address
    },
    computed: {
        addresses() {
            return this.member.addresses || [];
        },
        ...mapGetters({
            member: 'auth/member'
        })
    }
};
</script>

<style lang="sass" scoped>

.add-address
  @apply flex flex-col justify-center items-center
  transition: background .15s ease, color .15s ease
  min-height: 120px
  @screen md
    min-height: 200px
  &::v-deep
    p
      @apply mb-2

.edit-address,
.add-address
  &:hover,
  &:focus
    @apply outline-black
    // background: var(--color-primary)
    // --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
    // color: hsl(0, 0%, var(--switch))

.addresses
  @apply inline-flex flex-row flex-wrap
  --gap: 1rem
  margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap))
  width: calc(100% + var(--gap))
  & > *
    @apply flex-grow
    margin: var(--gap) 0 0 var(--gap)
    max-width: 100%
    min-width: 80%
    @screen md
      max-width: 50%
      min-width: 200px
    @screen lg
      max-width: 33.3333333%
      min-width: 25%
    @screen xl
      max-width: 25%
      min-width: 20%
    @screen 2xl
      max-width: 20%
      min-width: 16%
</style>
